// extracted by mini-css-extract-plugin
module.exports = {"CodePage":"CodePage_CodePage__3tPi-","CodeContainer":"CodePage_CodeContainer__pUGkA","code":"CodePage_code__2sPhP","BtnContainer":"CodePage_BtnContainer__1KOJ4"};